<template>
  <div class="card-base card-shadow--small records-list-tree ">
    <h1 class="title">
      <span>{{$t('common.three_list.latest_records')}}</span>
      <small v-if="isShowMore" @click="goRouter">{{$t('common.three_list.view_more')}}</small>
    </h1>
    <div v-if="params.length" :style="{ height: height + 'px' }">
        {{params.status}}
      <el-card class="box-card" v-for="(parent, key) in params" :class="classCardColor(params[key].status)" :key="key">
        <el-row :gutter="10">
          <el-col :xs="16" :sm="16" :md="16" :lg="16" :xl="16">
            <!-- <el-tag class="status-width" :class="classColor(parent.status)">{{getKey(parent.status)}}</el-tag> -->
            <b style="line-height:40px;" >{{$t('common.three_list.order_No')}}{{parent.orderId}}</b>
          </el-col>
          <el-col class="text-right" :xs="8" :sm="8" :md="8" :lg="8" :xl="8">
            <el-button v-if="type && !['deposit','transfer'].includes(type) && !statusCancel.includes(parent.status)"  type="primary" @click="cencelFun(parent.orderId)" size="mini">{{$t('common.three_list.cenceledBtn')+getKey(type)}}</el-button>
          </el-col>
          <!-- <el-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8" class="hidden-md-and-up">
            <small>{{parent.updatedTime | GetDate}} {{parent.updatedTime | GetTime}}</small>
          </el-col> -->
        </el-row>
        <el-row :gutter="10" v-for="(child, key02) in parent.childList" :key="key02">
          <el-col :xs="7" :sm="12" :md="12" :lg="12" :xl="12" class="param-name content-left" v-if="child">{{getKey(key02)}}</el-col>
          <el-col :xs="17" :sm="12" :md="12" :lg="12" :xl="12" class="param-value text-right content-right" ><small class="data-con">{{child}}</small></el-col>
        </el-row>
      <!-- <img class="status-img" v-if="type == 'deposit'" :src="selectLang==='cn'?statusIcon1[parent.status].icon1:statusIcon1[parent.status].icon2" /> -->
      <img class="status-img" v-if="type == 'deposit'" :src="imgType(statusIcon1,parent.status)" />
      <!-- <img class="status-img" v-else :src="selectLang==='cn'?statusIcon[parent.status].icon1:statusIcon[parent.status].icon2" /> -->
      <img class="status-img" v-else :src="imgType(statusIcon,parent.status)" />
      </el-card>
    </div>
    <!-- <div v-if="!params.length" v-loading="loading" class="loading" :style="{ height: height + 'px' }"></div> -->
    <div v-if="!params.length" :style="{ height: height + 'px' }">
      <el-card class="box-card ai-jc" :style="{ height: height-20 + 'px' }">
        <img :src="src" alt="noRecord" style="height:40px;width:40px">
        <div class="no-data">{{text}}</div>
      </el-card>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    params: {
      type: Array,
      default: () => []
    },
    router: String,
    height: String,
    src: String,
    text: String,
    type: String,
    isShowMore: {
      type: Boolean,
      default: true
    }
  },

  data () {
    return {
      loading: true,
      statusCancel: ['FAILURE', 'COMPLETED', 'CANCELED', 'CHECKING', 'PROCESSING', 'VERIFIED', 'WITHDRAWN'],
      statusIcon: {
        WITHDRAWN: {
          icon1: require('@/assets/images/withdrawn.png'),
          icon2: require('@/assets/images/withdrawn.png'),
          className: 'withdrawn'
        },
        PROCESSING: {
          icon1: require('@/assets/images/records-processing-zhans.png'),
          icon2: require('@/assets/images/records-processing-zhant.png'),
          icon3: require('@/assets/images/records-processing-en.png'),
          className: 'reviewing'
        },
        CANCELED: {
          icon1: require('@/assets/images/records-canceled-zhans.png'),
          icon2: require('@/assets/images/records-canceled-zhant.png'),
          icon3: require('@/assets/images/records-canceled-en.png'),
          className: 'origin'
        },
        COMPLETED: {
          icon1: require('@/assets/images/records-completed-zhans.png'),
          icon2: require('@/assets/images/records-completed-zhant.png'),
          icon3: require('@/assets/images/records-completed-en.png'),
          className: 'review-success'
        },
        FAILURE: {
          icon1: require('@/assets/images/records-failure-zhans.png'),
          icon2: require('@/assets/images/records-failure-zhant.png'),
          icon3: require('@/assets/images/records-failure-en.png'),
          className: 'review-failure'
        },
        REJECT: {
          icon1: require('@/assets/images/records-failure-zhans.png'),
          icon2: require('@/assets/images/records-failure-zhant.png'),
          icon3: require('@/assets/images/records-failure-en.png'),
          className: 'review-failure'
        },
        SUBMITTED: {
          icon1: require('@/assets/images/records-submitted-zhans.png'),
          icon2: require('@/assets/images/records-submitted-zhant.png'),
          icon3: require('@/assets/images/records-submitted-en.png'),
          className: 'reviewing'
        },
        CHECKING: {
          icon1: require('@/assets/images/records-processing-zhans.png'),
          icon2: require('@/assets/images/records-processing-zhant.png'),
          icon3: require('@/assets/images/records-processing-en.png'),
          className: 'reviewing'
        },
        VERIFIED: {
          icon1: require('@/assets/images/records-processing-zhans.png'),
          icon2: require('@/assets/images/records-processing-zhant.png'),
          icon3: require('@/assets/images/records-processing-en.png'),
          className: 'reviewing'
        }
      },
      statusIcon1: {
        PROCESSING: {
          icon1: require('@/assets/images/records-submitted-zhans.png'),
          icon2: require('@/assets/images/records-submitted-zhant.png'),
          icon3: require('@/assets/images/records-submitted-en.png'),
          className: 'reviewing'
        },
        CANCELED: {
          icon1: require('@/assets/images/records-canceled-zhans.png'),
          icon2: require('@/assets/images/records-canceled-zhant.png'),
          icon3: require('@/assets/images/records-canceled-en.png'),
          className: 'origin'
        },
        COMPLETED: {
          icon1: require('@/assets/images/records-completed-zhans.png'),
          icon2: require('@/assets/images/records-completed-zhant.png'),
          icon3: require('@/assets/images/records-completed-en.png'),
          className: 'review-success'
        },
        FAILURE: {
          icon1: require('@/assets/images/records-failure-zhans.png'),
          icon2: require('@/assets/images/records-failure-zhant.png'),
          icon3: require('@/assets/images/records-failure-en.png'),
          className: 'review-failure'
        },
        REJECT: {
          icon1: require('@/assets/images/records-failure-zhans.png'),
          icon2: require('@/assets/images/records-failure-zhant.png'),
          icon3: require('@/assets/images/records-failure-en.png'),
          className: 'review-failure'
        },
        SUBMITTED: {
          icon1: require('@/assets/images/records-submitted-zhans.png'),
          icon2: require('@/assets/images/records-submitted-zhant.png'),
          icon3: require('@/assets/images/records-submitted-en.png'),
          className: 'reviewing'
        },
        CHECKING: {
          icon1: require('@/assets/images/records-submitted-zhans.png'),
          icon2: require('@/assets/images/records-submitted-zhant.png'),
          icon3: require('@/assets/images/records-submitted-en.png'),
          className: 'reviewing'
        },
        VERIFIED: {
          icon1: require('@/assets/images/records-submitted-zhans.png'),
          icon2: require('@/assets/images/records-submitted-zhant.png'),
          icon3: require('@/assets/images/records-submitted-en.png'),
          className: 'reviewing'
        }
      }
    }
  },
  created () {
    // let curLang = sessionStorage.getItem('language')
    //   ? sessionStorage.getItem('language')
    //   : 'cn'

    // this.$store.dispatch('selectLang', curLang)
  },
  mounted() {
    console.log(this.params, 'params1')
  },
  methods: {
    imgType(list, status) {
      let initImg = ''
      if (this.selectLang === 'cn') {
        initImg = list[status].icon1
      } else if (this.selectLang === 'en') {
        initImg = list[status].icon3
      } else {
        initImg = list[status].icon2
      }
      return initImg
    },
    goRouter () {
      this.$router.push({
        name: 'records',
        query: { activeName: this.router ? this.router : 'deposit' }
      })
    },
    cencelFun (orderId) {
      this.$emit('cencelFun', orderId)
    },
    getKey (key) {
      let items = this.$t('common.three_list')
      return items[key] ? items[key] : key
    },
    classColor (status) {
      console.log(status)
      // "submitted": ["已提交", "已提交", "Submitted"],
      // "checking": ["校验中", "校驗中", "Checking"],
      // "verified": ["已校验", "已校驗", "Verified"],
      // "processing": ["在处理", "在處理", "Processing"],
      // "completed": ["完成", "完成", "Completed"],
      // "failure": ["失败", "失敗", "Failure"]
      return {
        'status-completed': status === 'COMPLETED',
        'status-failure': status === 'FAILURE',
        'status-submitted': status === 'SUBMITTED',
        'status-checking': status === 'CHECKING',
        'status-processing': status === 'PROCESSING',
        'status-verified': status === 'VERIFIED'
      }
    },
    classCardColor (status) {
      // "submitted": ["已提交", "已提交", "Submitted"],
      // "checking": ["校验中", "校驗中", "Checking"],
      // "verified": ["已校验", "已校驗", "Verified"],
      // "processing": ["在处理", "在處理", "Processing"],
      // "completed": ["完成", "完成", "Completed"],
      // "failure": ["失败", "失敗", "Failure"]
      if (this.type === 'deposit') {
        return {
          'box-card-completed': status === 'COMPLETED',
          'box-card-failure': status === 'FAILURE',
          'box-card-submitted': status === 'SUBMITTED' || status === 'VERIFIED' || status === 'PROCESSING' || status === 'CHECKING',
          'box-card-canceled': status === 'CANCELED'
        }
      }
      return {
        'box-card-completed': status === 'COMPLETED',
        'box-card-failure': status === 'FAILURE' || status === 'REJECT',
        'box-card-submitted': status === 'SUBMITTED',
        'box-card-canceled': status === 'CANCELED',
        'box-card-processing': status === 'PROCESSING' || status === 'CHECKING' || status === 'VERIFIED',
        'box-card-withdrawn': status === 'WITHDRAWN'
      }
    }
  },
  computed: {
    ...mapGetters(['getUser', 'selectLang', 'getAccountInfo'])
  },
  filters: {
    GetDate (timestamp) {
      var date = new Date(timestamp)
      var Y = date.getFullYear() + '-'
      var M =
        (date.getMonth() + 1 < 10
          ? '0' + (date.getMonth() + 1)
          : date.getMonth() + 1) + '-'
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      return Y + M + D
    },
    GetTime (timestamp) {
      var date = new Date(timestamp)
      var h =
        (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
      var m =
        (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        ':'
      var s =
        date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
      return h + m + s
    }
  }
}
</script>

<style lang="scss">
.records-list-tree {
  overflow: auto;
  .data-time{
    color: #7d7d7d;
  }
  .data-con{
    font-size: 12px;
  }
  .el-row:not(:first-child) {
    border-top: 1px solid #e2e2e2;
  }
  .el-card{
    border: none;
    border-left: 2px solid #ededed;
    border-right: 2px solid #ededed;
  }

  margin: 0;
  background: #fff;
  padding: 0 30px;

  .title {
    border-bottom: 4px solid #e2e2e2;
    margin: 0;
    padding: 20px 0;
    font-weight: 600;
    color: #182a54;
    font-size: 18px;
    font-family: Muli-Bold;

    span {
      display: inline-block;
      width: 50%;
    }

    small {
      display: inline-block;
      width: 50%;
      text-align: right;
      font-size: 1rem;
      font-weight: 400;
      color: #fec000;
      cursor: pointer;
    }
  }

  .loading {
    height: 500px;
  }
  .no-data {
    font-family: PingFangTC-Regular;
    font-size: 12px;
    color: #7d7d7d;
    letter-spacing: -0.19px;
    margin-top: 16px;
  }
  .ai-jc {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
  .status-width {
    text-align: center;
    color: #fff;
    width: 100px;
  }

  .loading {
    height: 500px;
  }

  .status-width {
    text-align: center;
    color: #fff;
    width: 100px;
  }
  .text-right {
    text-align: right;
    padding-top: 4px;
    line-height: 16px;
  }
  .t-c {
    text-align: center;
  }
  .status-completed {
    background-color: #7BCC5B;
  }
  .status-failure {
    background-color: #E02A2A;
  }
  .status-submitted, .status-checking, .status-processing, .status-verified {
    background-color: #7D7D7D;
  }
  .box-card-completed {
    border-bottom: 4px solid #7BCC5B;
  }
  .box-card-failure {
    border-bottom: 4px solid #E02A2A;
  }
  .box-card-submitted{
    border-bottom: 4px solid #ffe080;
  }
  .box-card-canceled{
    border-bottom: 4px solid #7D7D7D;
  }
  .box-card-checking, .box-card-processing, .box-card-verified{
    border-bottom: 4px solid #14b3ff;
  }
  .box-card-withdrawn {
    border-bottom: 4px solid #FE7000;
  }

  .box-card {
    position: relative;
    margin: 20px 0;
    .el-button--primary span {
    font-family: Muli-Bold;
    font-size: 14px;
    color: #193060;
    letter-spacing: 0.17px;
  }
  }
  .content-right {
    font-size: 12px;
    color: #24282d;
    font-weight: bold;
    word-wrap:break-word
  }
  .content-left {
    font-size: 12px;
    padding-top: 4px;
    color: #7d7d7d;
    font-family: 'Muli-Regular';
  }
  .el-card__body {
    padding: 6px 40px;
  }
  .status-img{
    position:absolute;
    width: 60px;
    top: 0;
    right: 0;
  }
  .el-row {
    padding: 8px 0;

    .param-name,
    .param-value {
      // font-size: 14px;
    }

    .param-name {
      // color: #999;
    }
  }
}
</style>
